<template>
  <div id="company-files" class="is-full-height">

    <IndexTable
        :columns="defaultTableColumns"
        default-status-filter="active"
        :display-status-filter="false"
        :display-actions="false"
        :displaySettings="false"
        :items="files"
        resource="opr-file"
        title="Submitted Bids"
        @click="handleShow"
    />

  </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";
import {storeToRefs} from "pinia";
import IndexTable from "@/components/IndexTable.vue";
import {useBidPackageCompanyFileStore} from "@/stores/BidPackageCompanyFileStore";
import BidPackageCompanyFileAPI from '@/api/BidPackageCompanyFileAPI';
import type {OPRFile} from '@/models/OPRFile';
import {useProjectStore} from '@/stores/ProjectStore';
import NotificationError from '@/use/NotificationError';

const { bidPackageCompanyFiles } = storeToRefs(useBidPackageCompanyFileStore());
const {project} = storeToRefs(useProjectStore());
const tableColumns = [
  // {
  //   field: 'id',
  //   label: 'ID',
  //   width: 40,
  //   numeric: true,
  // },
  {
    field: 'name',
    label: 'File',
    component: 'ExternalFileColumn',
    sortable: true,
  },
  {
    field: 'trade',
    label: 'Trade',
    component: 'TradeColumn',
    sortable: true,
  },
  {
    field: 'description',
    label: 'Comment',
    component: 'HTMLColumn',
  },
  {
    field: 'uploaded_at',
    label: 'Uploaded At',
    component: 'DateColumn',
    sortable: true,
  },
];

const props = withDefaults(defineProps<{
  bidPackageId: number | null,
}>(), {
  bidPackageId: null,
});
const {
  bidPackageId,
} = toRefs(props);

const defaultTableColumns = computed(() => Number(bidPackageId.value) > 0
  ? tableColumns.filter(column => column.field !== 'trade')
  : tableColumns);

const files = computed(() => bidPackageCompanyFiles.value || []);

function handleShow(file: OPRFile) {
  if (!file.id || !project.value?.id || bidPackageId.value === null) {
    return;
  }

  new BidPackageCompanyFileAPI().download(
    Number(project.value?.id),
    Number(bidPackageId.value),
    file,
  ).catch(error => {
    if (error?.errors) {
      NotificationError({}, error);
    } else {
      NotificationError({message: error || 'Unable to download the file.'});
    }
  });
}

</script>

<style lang="scss" scoped>

#company-files {
}

</style>

<style lang="scss">

#company-files {
  a {
    border: 0;
  }

}

</style>
